import React from "react";
import { Check, X } from "lucide-react";

interface PasswordRequirementsProps {
  requirements: string[];
  metRequirements: boolean[];
}

export function PasswordRequirements({ requirements, metRequirements }: PasswordRequirementsProps) {
  return (
    <div className="mt-2 space-y-2">
      {requirements.map((requirement, index) => (
        <div key={index} className="flex items-center gap-2 text-sm">
          {metRequirements[index] ? (
            <Check className="h-4 w-4 text-green-500" />
          ) : (
            <X className="h-4 w-4 text-red-500" />
          )}
          <span>{requirement}</span>
        </div>
      ))}
    </div>
  );
} 